/** "Take signed-in searches for others" on a shared browser. Off by default:
 *  those searches run under this browser's own X, LinkedIn or Facebook
 *  accounts, so a site's limit or ban lands on them. Only shown for a shared
 *  browser, since the server ignores it on any other. */
export default function ConsoleForOthersToggle({
  on,
  busy,
  onChange,
}: {
  on: boolean;
  busy?: boolean;
  onChange: (on: boolean) => void;
}) {
  return (
    <label className="mt-1 flex items-start gap-2 text-xs text-gray-600 dark:text-gray-300">
      <input
        type="checkbox"
        className="mt-0.5"
        checked={on}
        disabled={busy}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        Take signed-in searches for others. Its console also takes other users' searches
        once they have waited 10 minutes for their own. They run under the accounts signed
        in on this browser, so any site limit or ban lands on them.
      </span>
    </label>
  );
}
